import React from 'react';

const PastFiliochtQuestions = {
  "geibh": {  // Géibheann
    "I": {
      "2024": "Tugtar léiriú dúinn sa dán Géibheann (thíos) ar an gcodarsnacht idir dhá thréimhse éagsúla i saol an ainmhí.' É sin a phlé.",
      "2021": "Sa dán Géibheann (thíos), is trí shúile an ainmhí féin a fhaighimid léargas ar an gcodarsnacht idir an cineál saoil a bhí aige tráth agus an cineál saoil atá aige anois.' É sin a phlé.",
      "2017": "Úsáideann an file codarsnacht shoiléir chun dhá phictiúr (íomhá) den ainmhí a chur os ár gcomhair sa dán Géibheann (thíos).' É sin a phlé."
    },
    "II": {
      "2024": "Tá na focail sa dán i mbéal an ainmhí. Cén éifeacht a bhaineann leis an teicníc fhileata sin sa dán, dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2021": "An teideal oiriúnach ar an dán é Géibheann, dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2017": "Conas a chuaigh an dán seo i bhfeidhm ort? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)"
    },
    "III": {
      "2021": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin.",
      "2017": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile seo."
    }
  },
  "tearrach": {  // An tEarrach Thiar
    "I": {
      "2024": "Sa dán An tEarrach Thiar (thíos), tá an file ag cuimhneamh siar ar an gcineál saoil a bhí ar a oileán dúchais le linn a óige.' É sin a phlé.",
      "2022": "Sa dán An tEarrach Thiar (thíos), tugann an file cuntas dúinn ar na radhairc agus ar na fuaimeanna a bhain le saol an oileáin le linn a óige.' É sin a phlé.",
      "2019": "Cuimhní an fhile ar nósanna a bhain le saol an oileáin ina óige atá sa dán An tEarrach Thiar (thíos).' É sin a phlé.",
      "2016": "Cad é an príomhthéama sa dán An tEarrach Thiar (thíos), dar leat? Déan plé ar na híomhánna a úsáideann an file sa dán chun an príomhthéama sin a léiriú."
    },
    "II": {
      "2024": "Cén éifeacht atá ag athrá na bhfocal 'San Earrach thiar' ag deireadh gach véarsa, dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2022": "Críochnaíonn gach véarsa leis na focail 'San Earrach thiar.' Cén tábhacht a bhaineann leis an athrá sa líne dheireanach de gach véarsa, dar leat? (Is leor point amháin eolais as an dán thacaíocht le do fhreagra.)",
      "2019": "Cén mothúchán is mó a mhúsclaíonn an dán seo ionat féin? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2016": "Cad é an mothúchán is láidre a léiríonn an file sa dán seo? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)"
    },
    "III": {
      "2024": "Roghnaigh dhá cheann de na haidiachtaí a úsáideann an file sa dán. Déan plé ar an tábhacht a bhaineann leo sa dán, dar leat.",
      "2022": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin.",
      "2019": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin.",
      "2016": "Úsáideann an file go leor aidiachtaí sa dán. Roghnaigh dhá cheann de na haidiachtaí sin agus déan plé gairid ar an tábhacht a bhaineann leo sa dán, dar leat."
    }
  },
  "spailpin": {  // An Spailpín Fánach
    "I": {
      "2023": "Sa dán An Spailpín Fánach (thíos), tugann an spailpín cuntas dúinn ar a shaol dian ainnis in Éirinn na linne sin.' É sin a phlé.",
      "2021": "Sa dán An Spailpín Fánach (thíos), tugann an spailpín cuntas pearsanta dúinn ar a shaol in Éirinn na linne sin.' É sin a phlé.",
      "2018": "Tá brón agus bród an spailpín le feiceáil go soiléir sa dán An Spailpín Fánach (thíos).' É sin a phlé.",
      "2014": "Tugann an file cur síos éifeachtach dúinn ar shaol agus ar chás an spailpín sa dán An Spailpín Fánach (thíos).' É sin a phlé."
    },
    "II": {
      "2023": "Cén chaoi a dtéann an dán seo i bhfeidhm ort? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2021": "Cén mothúchán is mó a mhúsclaíonn an dán seo ionat féin? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2018": "Conas a chuaigh an dán seo i bhfeidhm ort? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2014": "Cad é an mothúchán is mó sa dán seo, dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)"
    },
    "III": {
      "2023": "Cén mheadaracht atá sa dán seo? Scríobh pointe amháin eolais faoin meadaracht seo agus léirigh do fhreagra le sampla cruinn ón dán.",
      "2021": "Cén mheadaracht atá sa dán seo? Scríobh pointe amháin eolais faoin meadaracht seo agus léirigh do fhreagra le sampla cruinn ón dán.",
      "2018": "Cén mheadaracht atá sa dán seo? Scríobh pointe amháin eolais faoin meadaracht seo agus léirigh do fhreagra le sampla cruinn ón dán.",
      "2014": "Cén mheadaracht atá sa dán seo? Scríobh pointe amháin eolais faoin meadaracht seo agus léirigh do fhreagra le sampla cruinn ón dán."
    }
  },
  "colscaradh": {  // Colscaradh
    "I": {
      "2022": "Sa dán Colscaradh (thíos), tugann an file cuntas dúinn ar dhá dhearcadh dhifriúla i leith an phósta.' É sin a phlé.",
      "2015": "Tá codarsnacht idir dhá thuiscint dhifriúla ar an bpósadh sa dán Colscaradh (thíos).' É sin a phlé."
    },
    "II": {
      "2022": "Cén éifeacht a bhaineann leis an dá líne dheireanacha den dán, dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2015": "Cad é an mothúchán is mó a mhúsclaíonn an dán seo ionat féin? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)"
    },
    "III": {
      "2022": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin.",
      "2015": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile."
    }
  },
  "moghrasa": {  // Mo ghrá-sa
    "I": {
      "2023": "Sa dán Mo ghrá-sa (idir lúibíní) (thíos), baineann an file úsáid as íomhánna ón nádúr chun cuma agus tréithe an fhir a chur in iúl dúinn.' É sin a phlé.",
      "2020": "Cad é príomhthéama an dáin Mo ghrá-sa (idir lúibíní) (thíos), dar leat? Déan plé ar na híomhánna a úsáideann an file sa dán chun an príomhthéama sin a léiriú."
    },
    "II": {
      "2023": "Cén ghné is mó den dán a thaitníonn leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)",
      "2020": "An teideal oiriúnach ar an dán é Mo ghrá-sa (idir lúibíní), dar leat? (Is leor pointe amháin eolais as an dán mar thacaíocht le do fhreagra.)"
    },
    "III": {
      "2023": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin.",
      "2020": "Cé a chum an dán seo? Scríobh nóta gairid ar shaol agus ar shaothar an fhile sin."
    }
  }
};

export default PastFiliochtQuestions; 